import { getStore } from '../store/store';
import { loading, stoppedLoading } from '../actions/internalActions';
import { mutator } from 'satcheljs';

mutator(loading, () => {
    getStore().isLoading = true;
});

mutator(stoppedLoading, () => {
    getStore().isLoading = false;
});
